import { EnumFiscalResidence } from '@blank/api'
import { CountryConfig, EnumHomeCountryCode } from '../../types'

export const BLANK_FR_COUNTRY_CONFIG: CountryConfig = {
  canAddCompanyDataManually: false,
  companyIdentificationNumberLength: 9,
  shouldChooseDomiciliationOnSignup: false,
  isBeta: false,
  canAddEnterpriseMandate: true,
  shouldDisplayUserFeedbackButton: false,
  isSponsorshipEnabled: false,
  increaseTransferLimitTypeformId: 'C9OWESfP',
  feedbackTypeformId: '',
  accountClosingTypeformId: 'YdO8BtiT',
  shouldDisplayAdditionalTouOnSelectOffer: false,
  fiscalResidenceOptions: [EnumFiscalResidence.FRA, EnumFiscalResidence.USA],
  homeCountryCode: EnumHomeCountryCode.FRA,
  invoicing: {
    canCreateEstimateDocument: true,
    canAddFiscalTaxesToDocument: false,
    canAddFiscalStampToDocument: false,
    shouldSelectVATExonerationCode: false,
  },
  shouldDisplayAverageBalanceDocuments: false,
  shouldBuildMicroEnterpriseCreationURLWithParams: false,
  whatsAppSupportNumber: undefined,
  shouldCustomizeCardFraudInsuranceRedirectionUrl: true,
  fileComplaintTypeformId: 'KHlIE416',
  shouldDisplayZendeskMessagingWidget: true,
  zendeskScriptKey: process.env.NEXT_PUBLIC_IS_PRODUCTION
    ? '89ed6c2a-1f9c-48eb-831d-2ad30922ad70'
    : '3ce58b8a-0ad3-495a-a01b-716955fdb412',
  hasOptionalConsents: false,
}
